import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';

// Note: `placeholderData: keepPreviousData`, staleTime and gcTime are configured
// globally in index.js (QueryClient defaults) so every query keeps the previous
// result on screen while refetching — no more blank flashes on navigation.
export function usePost(path, body, enabled = true, options = {}) {
  const { refetchInterval, staleTime } = options;
  return useQuery({
    queryKey: [path, body],
    queryFn: async () => (await api.post(path, body)).data,
    enabled: enabled && !!body?.association,
    // Rafraîchissement automatique « quasi temps réel » optionnel (ex. tableau de bord) :
    // ré-interroge périodiquement pour refléter la synchro Evergiving de fond SANS action
    // manuelle. React Query ne poll PAS en arrière-plan par défaut (onglet inactif).
    ...(refetchInterval ? { refetchInterval } : {}),
    ...(staleTime !== undefined ? { staleTime } : {}),
    // Heavy analytics endpoints can be briefly slow on a cold start (right after a
    // deploy). Auto-retry transient timeouts/network/5xx so the UI self-heals
    // instead of showing an error — but never retry auth/permission failures.
    retry: (failureCount, error) => {
      const s = error?.response?.status;
      if (s === 401 || s === 403 || s === 404) return false;
      return failureCount < 2;
    },
    retryDelay: (attempt) => Math.min(1500 * 2 ** attempt, 6000),
  });
}

export function useGet(path, params, enabled = true) {
  return useQuery({
    queryKey: [path, params],
    queryFn: async () => (await api.get(path, { params })).data,
    enabled,
  });
}
